import { create } from 'zustand';

interface GalleryFilters {
  category: string;
  tag: string;
  search: string;
  sort: string;
  page: number;
}

interface GalleryState {
  filters: GalleryFilters;
  setFilters: (filters: Partial<GalleryFilters>) => void;
  resetFilters: () => void;
}

const defaultFilters: GalleryFilters = {
  category: '',
  tag: '',
  search: '',
  sort: 'newest',
  page: 1,
};

const useGalleryStore = create<GalleryState>((set) => ({
  filters: { ...defaultFilters },
  setFilters: (updates) =>
    set((state) => ({
      filters: { ...state.filters, ...updates, page: updates.page ?? 1 },
    })),
  resetFilters: () => set({ filters: { ...defaultFilters } }),
}));

export default useGalleryStore;
